<template>
    <v-container class="py-0">
        <v-row>
            <v-col cols="6" data-test-id="hotVolcano">
                <v-switch v-model="hotVulcan" inset label="Горячая вулканизация" color="success" hide-details class="mt-0"></v-switch>
                <span v-if="hotVulcanPrice" class="addprice">({{hotVulcanPrice}})</span>
            </v-col>
            <v-col cols="6">
                <v-switch v-model="edgeRestoration" inset label="Восстановление защитной кромки" color="success" hide-details class="mt-0" :disabled="cutType"></v-switch>
                <span v-if="edgeRestorationPrice" class="addprice">({{edgeRestorationPrice}})</span>
                <!--v-switch
                        v-model="cameraRepair"
                        inset
                        :label="cameraRepair?'Ремонт камеры,' + cameraRepairVol + ' шт':'Ремонт камеры +' + cameraRepairPrice + '₽'"
                        color="success"
                        hide-details
                        class="mt-0"
                        :class="cameraRepair?'mb-3':''"
                ></v-switch>
                <span v-if="cameraRepair">
                    <v-btn @click="cameraRepairVol==0?'':cameraRepairVol--" x-small fab depressed><v-icon>mdi-minus</v-icon></v-btn>
                    {{ cameraRepairVol }}
                    <v-btn @click="cameraRepairVol++" x-small fab depressed><v-icon>mdi-plus</v-icon></v-btn><span class="addpricetext">+ {{ cameraRepairPrice*cameraRepairVol }}₽</span>
                </span>
                <v-switch
                        v-model="hareness"
                        :label="hareness?'Установка жгута,' + harenessVol + ' шт':'Установка жгута +' + harenessPrice + '₽'"
                        color="success"
                        hide-details
                        class="mt-2 mb-3"
                ></v-switch>
                <span v-if="hareness">
                    <v-btn @click="harenessVol==0?'':harenessVol--" x-small fab depressed><v-icon>mdi-minus</v-icon></v-btn>
                    {{ harenessVol }}
                    <v-btn @click="harenessVol++" x-small fab depressed><v-icon>mdi-plus</v-icon></v-btn><span class="addpricetext">+ {{ harenessPrice*harenessVol }}₽</span>
                </span-->
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    export default {
        name: 'wheelRadius',
        props: ['side'],
        computed: {
            cutType () {
              return false
            },
            cameraRepairPrice(){
                return this.$store.state.repair.cameraRepairPrice
            },
            harenessPrice(){
                return this.$store.state.repair.harenessPrice
            },
            hotVulcanPrice () {
                return this.$store.state.repair.wheels[this.side].data.PatchSelected ? this.$store.state.repair.wheels[this.side].data.PatchSelected.extra_hot ? '+' + this.$store.state.repair.wheels[this.side].data.PatchSelected.extra_hot + '₽' : null : null
            },
            edgeRestorationPrice () {
                if (this.$store.state.repair.wheels[this.side].data.PatchSelected) {
                    if (this.$store.state.repair.wheels[this.side].data.PatchSelected.extra_repair) {
                        return '+ ' + Math.round(this.$store.state.repair.wheels[this.side].data.PatchSelected.price / 100 * this.$store.state.repair.wheels[this.side].data.PatchSelected.extra_repair) + '₽'
                    }
                }
                return null
            },
            hotVulcan: {
                get() {
                    return this.$store.state.repair.wheels[this.side].data.hotVulcan
                },
                set(value) {
                    this.$store.commit('repair/setPlus', { side: this.side, item: 'hotVulcan', value })
                }
            },
            edgeRestoration: {
                get() {
                    return this.$store.state.repair.wheels[this.side].data.edgeRestoration
                },
                set(value) {
                    this.$store.commit('repair/setPlusEdge', { side: this.side, item: 'edgeRestoration', value })
                }
            },
            cameraRepair: {
                get() {
                    return this.$store.state.repair.wheels[this.side].data.cameraRepair
                },
                set(value) {
                    this.$store.commit('repair/setPlus', { side: this.side, item: 'cameraRepair', value })
                }
            },
            cameraRepairVol: {
                get() {
                    return this.$store.state.repair.wheels[this.side].data.cameraRepairVol
                },
                set(value) {
                    this.$store.commit('repair/setPlus', { side: this.side, item: 'cameraRepairVol', value })
                }
            },
            hareness: {
                get() {
                    return this.$store.state.repair.wheels[this.side].data.hareness
                },
                set(value) {
                    this.$store.commit('repair/setPlus', { side: this.side, item: 'hareness', value })
                }
            },
            harenessVol: {
                get() {
                    return this.$store.state.repair.wheels[this.side].data.harenessVol
                },
                set(value) {
                    this.$store.commit('repair/setPlus', { side: this.side, item: 'harenessVol', value })
                }
            },
        },
    }
</script>
<style scoped>
    .addprice {
        margin-left: 57px;
    }
</style>
